var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentacao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "documentacao",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "documentacao_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nTFBzQ.tif_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.6,87.6c-2.1-2-4.1-4.2-6.3-6.1c-1.3-1.2-1.8-2.5-1.7-4.2c0.1-10.1,0-20.2,0-30.3c0-0.3,0-0.7,0-1.2 c-0.4,0-0.7,0-1.1,0c-11.1,0-22.2,0-33.4,0c-3.2,0-4.7,1.5-4.7,4.7c0,16.2,0,32.4,0,48.6c0,0.8-0.2,1.4-0.8,1.9 c-2.1,2.1-4.2,4.1-5.6,6.7c-0.6,1.1-1.1,2.2-1.7,3.3c-0.9-2.2-2.5-3-4.8-2.9c-13.7,0-27.3,0-41,0c-0.4,0-0.8,0-1.2,0 c0-23.5,0-46.8,0-70.3c0.4,0,0.8,0,1.2,0c13.6,0,27.2,0,40.9,0c3.4,0,6.4,0.8,9,3c0.1-0.1,0.3-0.2,0.4-0.3c2.3-1.9,5-2.8,8-2.8 c14.3,0,28.5,0,42.8,0C136.6,54.5,136.6,71.1,136.6,87.6z M42.3,100.2c0.5,0,0.9,0,1.3,0c9.5,0,19,0,28.6,0 c3.1,0,6.2-0.4,9.3,0.6c0-0.3,0-0.6,0-0.9c0-16.6,0-33.2,0-49.8c0-2.6-1.7-4.3-4.3-4.3c-11.3,0-22.6,0-33.9,0c-0.3,0-0.6,0-1,0 C42.3,64.1,42.3,82.1,42.3,100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.6,98c-8.5,8.7-17,17.4-25.4,26.1c-2.9,3-6.1,4.9-10.2,5.6c-5,0.9-9.9,2.2-14.8,3.3 c-0.4,0.1-0.7,0.1-1.2,0.3c0.1-0.6,0.2-1.1,0.3-1.6c1.2-5.4,2.5-10.9,3.7-16.3c0.5-2.4,1.6-4.6,3.3-6.4c9-9.3,18-18.5,27-27.8 c0,0,0.1-0.1,0.2-0.2c0.2,0.2,0.5,0.5,0.8,0.7c5.1,5.1,10.3,10.2,15.4,15.4c0.2,0.2,0.6,0.4,0.8,0.7 C136.6,97.9,136.6,98,136.6,98z M119.6,92.5c-7.2,7.4-14.4,14.8-21.5,22.1c1.9,1.9,3.8,3.8,5.7,5.7c7.1-7.3,14.3-14.7,21.5-22.1 C123.3,96.3,121.5,94.4,119.6,92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.6,124.2c-4.8,0-9.5,0-14.4,0c0.2-0.3,0.4-0.5,0.5-0.7c2.2-2.3,4.4-4.5,6.6-6.8c0.3-0.3,0.8-0.5,1.2-0.5 c2-0.1,4.1,0,6.1,0C136.6,118.9,136.6,121.5,136.6,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.1,116.3c-0.7,2.9-1.2,5.4-1.8,7.9c-14.7,0-29.2,0-43.9,0c0-2.6,0-5.2,0-8 C49.6,116.2,64.7,116.2,80.1,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.4,53.9c7.7,0,15.4,0,23.1,0c0,2.6,0,5.2,0,7.9c-7.7,0-15.3,0-23.1,0C50.4,59.2,50.4,56.6,50.4,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.4,67.9c0,2.7,0,5.2,0,7.9c-7.7,0-15.3,0-23.1,0c0-2.6,0-5.2,0-7.9C58,67.9,65.7,67.9,73.4,67.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.4,81.9c0,2.7,0,5.2,0,7.9c-5,0-10,0-15.1,0c0-2.6,0-5.2,0-7.9C55.4,81.9,60.4,81.9,65.4,81.9z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentacao);
export default __webpack_public_path__ + "static/media/documentacao.8d63b9fa8c58e7a42b1c677df4eba6f3.svg";
export { ForwardRef as ReactComponent };